import { useApiAction } from '../_shared/use-api-action';
import { familyDeviceApi } from './api';

export function useGetProfiles() {
  return useApiAction(familyDeviceApi.getProfiles);
}

export function useRequestGuardianCode() {
  return useApiAction(familyDeviceApi.requestGuardianCode);
}

export function useGuardianCodeLogin() {
  return useApiAction(familyDeviceApi.guardianCodeLogin);
}

export function useUnlink() {
  return useApiAction(familyDeviceApi.unlink);
}
